/* SeaFoodsShow cart consistency patch: use Shopify's server-side cart for all add-to-cart actions. */
(function () {
  function findVariantId(product) {
    if (!product) return null;
    let id = product.variant_id || product.variantId;
    if (id) return id;
    if (typeof STORE_DATA !== 'undefined') {
      const all = Object.values(STORE_DATA).flat();
      const match = all.find(p => p && p.variant_id && ((product.handle && p.handle === product.handle) || (product.title && p.title === product.title)));
      if (match) return match.variant_id;
    }
    return null;
  }

  window.addToCart = function (product, qty = 1) {
    const variantId = findVariantId(product);
    if (!variantId) {
      console.error('Cart add stopped: Shopify variant ID is missing for this product.', product);
      alert('This product could not be added right now. Please open the product page and try again.');
      return;
    }
    return window.ShopifyCart.add(variantId, Math.max(1, parseInt(qty, 10) || 1));
  };

  window.addMultipleToCart = function (items) {
    if (!Array.isArray(items) || !items.length) return;
    const normalized = items.map(({ product, qty }) => ({
      id: findVariantId(product),
      quantity: Math.max(1, parseInt(qty, 10) || 1)
    }));
    if (normalized.some(item => !item.id)) {
      alert('One of these products could not be added. Please add each item from its product page.');
      return;
    }
    return window.ShopifyCart.addMultiple(normalized);
  };

  // The old drawer rendered a separate localStorage cart. Refresh it from Shopify instead.
  window.renderCart = function () {
    if (window.ShopifyCart && typeof window.ShopifyCart.refresh === 'function') {
      return window.ShopifyCart.refresh();
    }
  };
})();